export enum CapabilityType {
    SHARING_CENTER = 'SHARING_CENTER',
    CREATE_FOLDER = 'CREATE_FOLDER',
    GENERATE_PLANOGRAM = 'GENERATE_PLANOGRAM',
    APPROVE_PLANOGRAM = 'APPROVE_PLANOGRAM',
    EDIT_PLANOGRAM = 'EDIT_PLANOGRAM',
    VIEW_PLANOGRAM = 'VIEW_PLANOGRAM',
    SAVE_PLANOGRAM = 'SAVE_PLANOGRAM',
    SAVENEW_PLANOGRAM = 'SAVENEW_PLANOGRAM',
    DELETE_PLANOGRAM = 'DELETE_PLANOGRAM',
    MOVE_PLANOGRAM = 'MOVE_PLANOGRAM',
    CREATE_PLANOGRAM = 'CREATE_PLANOGRAM',
    CLONE_PLANOGRAM = 'CLONE_PLANOGRAM',
    LOAD_PLANOGRAM = 'LOAD_PLANOGRAM',
    RESET_PLANOGRAM = 'RESET_PLANOGRAM',
    REFRESH_PLANOGRAM = 'REFRESH_PLANOGRAM',
    IMPORT_PRODUCTS = 'IMPORT_PRODUCTS',
    REMOVE_PRODUCTS = 'REMOVE_PRODUCTS',
    SHARE_PLANOGRAM = 'SHARE_PLANOGRAM',
    EXPORT = 'EXPORT',
    EDIT_OPTIONS = 'EDIT_OPTIONS',
    EDIT_NOTES = 'EDIT_NOTES',
    IMAGES_EDITOR = 'IMAGES_EDITOR',
    FEEDBACK = 'FEEDBACK'
}